const allProjectsData = [
    // Existing projects - Completed
    {
        "id": 1,
        "slug": "duplex-branduselor-floresti",
        "title": "Duplex House on Branduselor St, Florești",
        "category": "Duplex",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/3.png",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/casa-duplex-floresti/3.png",
        "year": "2021"
    },
    {
        "id": 2,
        "slug": "apartments-padurii-60-62",
        "title": "2 & 3 Room Apartments, Padurii St 60-62",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/1.png",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/1.png",
        "year": "2020"
    },
    {
        "id": 4,
        "slug": "apartments-padurii-62-donath",
        "title": "2 & 3 Room Apartments, Padurii St 62 (Donath Park)",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/1.png",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/1.png",
        "year": "2021"
    },
    {
        "id": 5,
        "slug": "apartments-terra-floresti-192",
        "title": "Apartments in Terra Florești (Sesul de Sus 192)",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/apartament-terra/1.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/apartament-terra/1.jpeg",
        "year": "2021"
    },
    {
        "id": 6,
        "slug": "project-sesul-de-sus-190",
        "title": "Commercial Space Sesul de Sus 190",
        "category": "Commercial Spaces",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/5.png",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/5.png",
        "year": "2022"
    },

    // Existing projects - Work In Progress
    {
        "id": 3,
        "slug": "duplex-iazului-floresti",
        "title": "Duplex House on Iazului St, Florești",
        "category": "Duplex",
        "status": "Work In Progress",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/1.png",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/1.png",
        "year": "2025"
    },
    {
        "id": 21,
        "slug": "terra-gardens-valea-chintaului",
        "title": "Terra Gardens",
        "category": "Apartments",
        "status": "Work In Progress",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/1.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Terra%20Gardens/1.jpeg",
        "year": "2025"
    },
    {
        "id": 7,
        "slug": "someseni-barc-st-1",
        "title": "Apartments Barc St 1 (61-63), Someșeni",
        "category": "Apartments",
        "status": "Work In Progress",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/someseni/4.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/someseni/4.jpeg",
        "year": "2025"
    },
    {
        "id": 8,
        "slug": "duplex-urusagului-floresti",
        "title": "Duplex Project - Urușagului St, Florești",
        "category": "Duplex",
        "status": "Work In Progress",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/1.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/duplex-urusagului/1.jpeg",
        "year": "2025"
    },

    // New projects - Completed Projects - Apartments
    // {
    //     "id": 9,
    //     "slug": "catanelor-2014-2016",
    //     "title": "Catanelor 2014-2016 - 96 Apartments",
    //     "category": "Apartments",
    //     "status": "Completed Projects",
    //     "image": "/images/placeholder-project.jpg",
    //     "mainImage": "/images/placeholder-project.jpg",
    //     "year": "2016"
    // },
    {
        "id": 10,
        "slug": "tauti-13-floresti",
        "title": "Tauti 13 Florești - Commercial Space & 7 Apartments",
        "category": ["Apartments", "Commercial Spaces"], // Multiple categories
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Tauti%2013%20Flore%C8%99ti%20-sp%20comercial%20%C8%99i%207ap%20-%202016/WhatsApp%20Image%202025-05-22%20at%2013.38.05%20(4).jpeg", // Placeholder
        "year": "2016"
    },
    {
        "id": 11,
        "slug": "catanelor-9b-9h",
        "title": "Floresti, str Cătanelor 9b și 9h - 25 Apartments",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Apartamente%20str%20c%C4%83tanelor%209b%20%C8%99i%209h%20-%2025%20ap%20An%202019-2021/WhatsApp%20Image%202025-05-22%20at%2013.38.08.jpeg", // Placeholder
        "year": "2021"
    },
    {
        "id": 12,
        "slug": "teilor-47-floresti",
        "title": "Str Teilor 47 Florești - 30 Apartments",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Str%20Teilor%2047%20Flore%C8%99ti%20%20An%202017%20%2030%20ap/WhatsApp%20Image%202025-05-22%20at%2013.38.09%20(3).jpeg", // Placeholder
        "year": "2017"
    },
    {
        "id": 13,
        "slug": "a-iancu-410-volvo",
        "title": "Str A Iancu 410 (Volvo) Florești - 60 Apartments",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Str%20A%20Iancu%20410_volvo%20Flore%C8%99ti%20%20An%202018-2020/WhatsApp%20Image%202025-05-22%20at%2013.38.10%20(1).jpeg", // Placeholder
        "year": "2020"
    },
    {
        "id": 14,
        "slug": "catanelor-11g-11k",
        "title": "Catanelor 11g și 11k - 60 Apartments",
        "category": "Apartments",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Catanelor%2011g%20%C8%99i%2011k%20-%2060%20ap%20Construc%C8%9Bie%202021-2023/WhatsApp%20Image%202025-05-22%20at%2013.38.12.jpeg", // Placeholder
        "year": "2023"
    },

    // New projects - Completed - Duplex
    {
        "id": 15,
        "slug": "ansamblu-duplexuri-urusagului",
        "title": "Ansamblu 15 Duplexuri Urusagului Florești",
        "category": "Duplex",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Ansamblu%2015%20duplexuri%20Urusagului%20Flore%C8%99ti%20An%202016-2019/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(2).jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Ansamblu%2015%20duplexuri%20Urusagului%20Flore%C8%99ti%20An%202016-2019/WhatsApp%20Image%202025-05-22%20at%2013.38.06%20(2).jpeg",
        "year": "2019"
    },
    {
        "id": 16,
        "slug": "duplexuri-narciselor",
        "title": "Duplexuri Floresti, Strada Narciselor",
        "category": "Duplex",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.07%20(1).jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Duplexuri%20narciselor%20An%202017-2018/WhatsApp%20Image%202025-05-22%20at%2013.38.07%20(1).jpeg",
        "year": "2018"
    },
    {
        "id": 17,
        "slug": "primele-duplexuri-urusagului",
        "title": "Primele Duplexuri 2014 Urusagului Florești",
        "category": "Duplex",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Primele%20duplexuri%202014%20Urusagului%20Flore%C8%99ti/WhatsApp%20Image%202025-05-22%20at%2013.38.10.jpeg",
        "year": "2014"
    },

    // New projects - Completed - Commercial Spaces
    {
        "id": 18,
        "slug": "spatiu-comercial-eroilor",
        "title": "Spatiu Comercial Eroilor 58H Floresti",
        "category": "Commercial Spaces",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Spatiu%20comercial%20eroilor%2058H%20Floresti/WhatsApp%20Image%202025-05-22%20at%2013.38.11.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Spatiu%20comercial%20eroilor%2058H%20Floresti/WhatsApp%20Image%202025-05-22%20at%2013.38.11.jpeg",
        "year": "2019"
    },
    {
        "id": 19,
        "slug": "spatiu-comercial-catanelor",
        "title": "Spatiu Comercial Catanelor 9B Floresti",
        "category": "Commercial Spaces",
        "status": "Completed Projects",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Sp%20comercial%20Catanelor%209B/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(1).jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Sp%20comercial%20Catanelor%209B/WhatsApp%20Image%202025-05-22%20at%2013.38.11%20(1).jpeg",
        "year": "2021"
    },
    {
        "id": 20,
        "slug": "stejarului-street",
        "title": "Stejarului Street",
        "category": "Commercial Spaces",
        "status": "Work In Progress",
        "image": "https://arcdom.b-cdn.net/arcdom-projects/Stejarului%20Street/WhatsApp%20Image%202025-05-28%20at%2021.49.23.jpeg",
        "mainImage": "https://arcdom.b-cdn.net/arcdom-projects/Stejarului%20Street/WhatsApp%20Image%202025-05-28%20at%2021.49.24.jpeg",
        "year": "2025"
    },

];

export default allProjectsData;
